import { PortalCommunicationOrderType, SortDirection } from "@/Common/Models/UI/Enums";

class PortalCommunicationTableSetting {
    public currentPageNumber: number = 1;
    public searchText: string = "";
    public queryOrderType: PortalCommunicationOrderType = PortalCommunicationOrderType.Date;
    public queryOrderDirection: SortDirection = SortDirection.DESC;

    constructor(init?: Partial<PortalCommunicationTableSetting>) {
        Object.assign(this, init);
    }
}

export { PortalCommunicationOrderType, PortalCommunicationTableSetting };
